import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './components/Home';
import MenuDatos from './components/MenuDatos';
import Clientes from './components/datos/Clientes';
import ClientesForm from './components/datos/ClientesForm';
import Productos from './components/datos/Productos';
import ProductosForm from './components/datos/ProductosForm';
import ProductosImportar from './components/datos/ProductosImportar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Marcas from './components/datos/Marcas';
import MarcasForm from './components/datos/MarcasForm';
import MenuPedidos from './components/MenuPedidos';
import MenuEstadisticas from './components/MenuEstadistica';
import MenuRanking from './components/MenuRanking';
import Pedidos from './components/pedidos/Pedidos';
import PedidosForm from './components/pedidos/PedidosForm';
import PedidosEntrega from './components/pedidos/PedidosEntrega';
import EstadisticasForm from './components/estadisticas/EstadisticasForm';
import ClientesCRM from './components/crm/ClientesCRM';
import Resenia from './components/crm/ReseniaCliente';
import Historial from './components/crm/Historial';
import RankingClientes from './components/ranking/RankingClientes';
import RankingMarcas from './components/ranking/RankingMarcas';
import Login from './components/login/Login';
import PrivateRoute from './utils/PrivateRoute';
import { useState } from 'react';
import UserContext from './utils/UserContext';
import { FaRightFromBracket } from 'react-icons/fa6';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import NotasCliente from './components/datos/NotasCliente';
import NotasForm from './components/datos/NotasForm';
import MenuCRM from './components/MenuCRM';
import MarcasCRM from './components/crm/MarcasCRM';
import ReseniaMarca from './components/crm/ReseniaMarca';
import EvolucionVentas from './components/estadisticas/EvolucionVentas';


function App() {
  const [user, setUser] = useState({login:false});

  function logout() {
    setUser({login:false});
    axios.defaults.headers.common['Authorization'] = undefined;
  }

  return (
    <div className="app">
      <UserContext.Provider value={user}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
      <header className="app-header">
        <h1>
          <img src={process.env.PUBLIC_URL+'/nuevologo.jpeg'} className='app-logo'/>
          <span>CRM Representaciones</span>
        </h1>
        {user?.login?
          <div className='logout'>
            <Button variant='link' onClick={logout}>
              <span> Salir </span><FaRightFromBracket></FaRightFromBracket>
            </Button>
          </div>:<></>
        }
      </header>
      <section className='container-fluid'>
          <Routes>
            <Route path="/login" element={<Login setUser={setUser}></Login>}></Route>
            <Route path="/" element={<PrivateRoute><Home/></PrivateRoute>}></Route>
            <Route path="/datos" element={<PrivateRoute><MenuDatos/></PrivateRoute>}></Route>
            <Route path="/pedidos" element={<PrivateRoute><MenuPedidos/></PrivateRoute>}></Route>
            <Route path="/estadistica" element={<PrivateRoute><MenuEstadisticas/></PrivateRoute>}></Route>
            <Route path="/ranking" element={<PrivateRoute><MenuRanking/></PrivateRoute>}></Route>
            <Route path="/clientes" element={<PrivateRoute><Clientes/></PrivateRoute>}></Route>
            <Route path="/clientes/:id" element={<PrivateRoute><ClientesForm/></PrivateRoute>}></Route>
            <Route path="/clientes/nuevo" element={<PrivateRoute><ClientesForm/></PrivateRoute>}></Route>
            <Route path="/productos" element={<PrivateRoute><Productos/></PrivateRoute>}></Route>
            <Route path="/productos/importar" element={<PrivateRoute><ProductosImportar/></PrivateRoute>}></Route>
            <Route path="/productos/nuevo" element={<PrivateRoute><ProductosForm/></PrivateRoute>}></Route>
            <Route path="/productos/:id" element={<PrivateRoute><ProductosForm/></PrivateRoute>}></Route>
            <Route path='/marcas' element={<PrivateRoute><Marcas/></PrivateRoute>}></Route>
            <Route path='/marcas/nueva' element={<PrivateRoute><MarcasForm/></PrivateRoute>}></Route>
            <Route path='/marcas/:id' element={<PrivateRoute><MarcasForm/></PrivateRoute>}></Route>
            <Route path="/pedidos/consulta" element={<PrivateRoute><Pedidos/></PrivateRoute>}></Route>
            <Route path="/pedidos/nuevo" element={<PrivateRoute><PedidosForm/></PrivateRoute>}></Route>
            <Route path="/pedidos/:id" element={<PrivateRoute><PedidosForm/></PrivateRoute>}></Route>
            <Route path="/pedidos/entrega" element={<PrivateRoute><PedidosEntrega/></PrivateRoute>}></Route>
            <Route path="/estadistica/ventas" element={<PrivateRoute><EstadisticasForm/></PrivateRoute>}></Route>
            <Route path="/estadistica/evolucion-ventas" element={<PrivateRoute><EvolucionVentas/></PrivateRoute>}></Route>
            <Route path="/crm/clientes" element={<PrivateRoute><ClientesCRM/></PrivateRoute>}></Route>
            <Route path="/crm/clientes/resenia/:id" element={<PrivateRoute><Resenia/></PrivateRoute>}></Route>
            <Route path="/crm/marcas/resenia/:id" element={<PrivateRoute><ReseniaMarca/></PrivateRoute>}></Route>
            <Route path="/crm/historial/:id" element={<PrivateRoute><Historial/></PrivateRoute>}></Route>
            <Route path="/ranking/clientes" element={<PrivateRoute><RankingClientes/></PrivateRoute>}></Route>
            <Route path="/ranking/marcas" element={<PrivateRoute><RankingMarcas/></PrivateRoute>}></Route>
            <Route path="/crm/notas/:id" element={<PrivateRoute><NotasCliente/></PrivateRoute>}></Route>
            <Route path="/crm/notas/:id/:nota_id" element={<PrivateRoute><NotasForm/></PrivateRoute>}></Route>
            <Route path="/crm/nuevanota/:id" element={<PrivateRoute><NotasForm/></PrivateRoute>}></Route>
            <Route path="/crm" element = {<PrivateRoute><MenuCRM/></PrivateRoute>}></Route>
            <Route path="/crm/marcas" element = {<PrivateRoute><MarcasCRM/></PrivateRoute>}></Route>
          </Routes>
      </section>
      <footer className="app-footer">
        <div className="copyrights">
          <p>&copy; 2024 MAO Software. Todos los derechos reservados.</p>
        </div>
      </footer>
      </BrowserRouter>
      </UserContext.Provider>
    </div>
  );
}

export default App;
